import { HumidityThresholds, HumidityLevel } from 'common';
import { tokens } from 'tamagui-config';

export const getHumidityLevel = (humidityValue: number): HumidityLevel => {
  const humidityLevels = Object.entries(HumidityThresholds)
    .map(([level, { low }]) => ({
      level: level as HumidityLevel,
      threshold: low,
    }))
    .sort((a, b) => b.threshold - a.threshold);

  const level = humidityLevels.find((hl) => humidityValue >= hl.threshold);
  return level ? level.level : HumidityLevel.Dry;
};

export const getHumidityColor = (humidityValue: number): string => {
  const level = getHumidityLevel(humidityValue);
  switch (level) {
    case HumidityLevel.VeryHumid:
    case HumidityLevel.Humid:
    case HumidityLevel.SlightlyHumid:
      return tokens.color.warning;
    case HumidityLevel.Dry:
      return tokens.color.warning;
    case HumidityLevel.Normal:
    default:
      return tokens.color.hgPrimary;
  }
};

export const getHumidityGradient = (humidityValue: number) => {
  const level = getHumidityLevel(humidityValue);
  switch (level) {
    case HumidityLevel.VeryHumid:
    case HumidityLevel.Humid:
    case HumidityLevel.SlightlyHumid:
      return {
        start: tokens.color.warning,
        end: tokens.color.warningAlpha20,
      };
    case HumidityLevel.Dry:
      return {
        start: tokens.color.warning,
        end: tokens.color.warningAlpha20,
      };
    case HumidityLevel.Normal:
    default:
      return {
        start: tokens.color.hgPrimary,
        end: tokens.color.info,
      };
  }
};

export const getHumidityStatus = (humidityValue: number): HumidityLevel =>
  getHumidityLevel(humidityValue);
